/**
 * useWebSocket hook.
 *
 * Returns the WebSocket context value provided by WebSocketProvider.
 * Must be called within a component tree wrapped by WebSocketProvider.
 *
 * Usage:
 *   const { status, subscribe, unsubscribe, onMessage, retry } = useWebSocket();
 *
 * @throws Error if called outside WebSocketProvider
 */
import { useContext } from 'react';
import { WebSocketContext } from './WebSocketProvider';
import type { WebSocketContextValue } from './WebSocketProvider';

/**
 * Returns the WebSocket context value (status, subscribe, onMessage, retry).
 *
 * @returns WebSocketContextValue from the nearest WebSocketProvider ancestor
 */
export function useWebSocket(): WebSocketContextValue {
  const ctx = useContext(WebSocketContext);
  if (!ctx) {
    throw new Error(
      '[useWebSocket] Must be called within a <WebSocketProvider>. ' +
      'Wrap your app in <WebSocketProvider> below <AuthProvider>.',
    );
  }
  return ctx;
}
